export const gray = {
  1: '#F2F5F7',
  2: '#EAEDF0',
  3: '#D0D8DD',
  4: '#98A8B3',
  5: '#667885',
  6: '#475A67',
  7: '#344854',
  8: '#1D2F39',
  9: '#00131D',
};

export const primary = {
  1: '#E9FBFD',
  2: '#BFF4FA',
  3: '#65F4FF',
  4: '#1FD9EE',
  5: '#13828F',
  6: '#0B4D55',
  7: '#062B30',
};

export const secondary = {
  1: '#E6F9FF',
  2: '#B6ECFF',
  3: '#6DDAFF',
  4: '#24C7FF',
  5: '#0083AF',
  6: '#005977',
  7: '#003649',
};

export const success = {
  1: '#E5FFEE',
  2: '#8DF3B6',
  3: '#36C88A',
  4: '#0E7A53',
  5: '#03482C',
};

export const warning = {
  1: '#FEF0C7',
  2: '#FEDF89',
  3: '#FAA71A',
  4: '#DC6803',
  5: '#7A2E0E',
};

export const error = {
  1: '#FEE4E2',
  2: '#FEB2AD',
  3: '#D82C0D',
  4: '#A21B00',
  5: '#55090A',
};

export const lightBlue = '#009CFF';

export const black = '#000000';
export const white = '#FFFFFF';

export const chartsTurquoise = '#26D9D9';
export const chartsYellow = '#FAA638';
export const chartsOrange = '#F3733F';
export const chartsOliveGreen = '#ABBD75';
export const chartsPurple = '#9E77ED';
export const chartsPink = '#F589D5';
export const secondaryRos600 = '#E31B54';
export const secondaryBlue600 = '#1570EF';
export const secondaryGreen800 = '#22774A';
export const secondaryBrown600 = '#B2804D';
export const secondaryMandarinOrange800 = '#902F09';
export const secondaryRos400 = '#FD6F8E';
export const secondaryPurple700 = '#6941C6';
export const secondaryMandarinOrange200 = '#F7A787';
export const secondaryBlue200 = '#B2DDFF';
export const secondaryTurquoise800 = '#178282';
export const secondaryOliveGreen300 = '#CBD6A9';

export const lineChartColors = [
  chartsTurquoise,
  chartsYellow,
  chartsOrange,
  chartsOliveGreen,
  chartsPurple,
  chartsPink,
  secondaryRos600,
  secondaryBlue600,
  secondaryGreen800,
  secondaryBrown600,
  secondaryMandarinOrange800,
  secondaryRos400,
  secondaryPurple700,
  secondaryMandarinOrange200,
  secondaryBlue200,
  secondaryTurquoise800,
  secondaryOliveGreen300,
];

// Light-theme line-chart palette + mode selector. Ported from development for
// the portfolio-perfomance-chart-type reused by the Options Flow net-flow card
// (IM-2016). Additive only — beta's existing `lightBlue` token is left as-is to
// avoid visual drift on other beta pages.
export const lineChartColorsLight = [
  '#145BF5',
  '#F99006',
  '#F45C30',
  '#22774A',
  '#6941C6',
  '#C11574',
  '#FEA3B4',
  '#26D9D9',
  '#96AC53',
  '#B2804D',
  '#C03F0C',
  '#F63D68',
  '#9B8AFB',
  '#F042BC',
  '#05256B',
  '#178282',
  '#5A6732',
];

export const getLineChartColors = (mode: 'light' | 'dark'): string[] =>
  mode === 'light' ? lineChartColorsLight : lineChartColors;
